export default {
  EXIBIR_CONSULTA_LEGISLACAO: true
}



// WEBPACK FOOTER //
// ./src/constants/pa/dadosEstado/analise.js